import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';
import Logo from "../Logo";
import css from './Header.module.css';
import { useSelector } from 'react-redux';
import { userSelectors } from '../../redux/user';
import isModalLogoutOpen from '../../redux/modalLogout/modalLogoutAction';
import { useDispatch } from "react-redux";
import ModalLogout from '../ModalLogout/ModalLogout';

export default function Header() {
    const changeLang = (ln) => {
        return () => {
            i18n.changeLanguage(ln);
            localStorage.setItem("lg", ln)
        };
    }
    const activeUser = useSelector(userSelectors.getUserName);
    const dispatch = useDispatch();
    const openModal = useSelector((state) => state.isModalLogoutOpen.modalLogout);
    const { t, i18n } = useTranslation();
    return (
        <header className={css.header}>
            <div className={css.wrap}>
                <Logo />
                <div className={css.inner}>
                    <p className={css.user}>{activeUser}<span className={css.sign}>|</span></p>
                    <button type="button" className={css.button} onClick={(e) => dispatch(isModalLogoutOpen())}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.2788 13.0708H12.6844V15.8818C12.6844 17.0443 11.7386 17.99 10.5761 17.99H2.10814C0.945786 17.99 0 17.0443 0 15.8818V2.10814C0 0.945786 0.945786 0 2.10814 0H10.5761C11.7386 0 12.6844 0.945786 12.6844 2.10814V4.91913H11.2788V2.10814C11.2788 1.72073 10.9637 1.40543 10.5761 1.40543H2.10814C1.72073 1.40543 1.40543 1.72073 1.40543 2.10814V15.8818C1.40543 16.2692 1.72073 16.5845 2.10814 16.5845H10.5761C10.9637 16.5845 11.2788 16.2692 11.2788 15.8818V13.0708ZM14.6872 5.68213L13.6934 6.67598L15.3096 8.29234H6.21922V9.69777H15.3096L13.6934 11.314L14.6872 12.3078L18 8.99506L14.6872 5.68213Z" fill="#BDBDBD" />
                        </svg>
                        <p className={css.title}>{t("logout")}</p>
                    </button>
                     <div className={css.containerBtn}>
                        <button className={css.ua} onClick={changeLang("ua")}></button>
                <button className={css.en} onClick={changeLang("en")}></button>
            </div>
                </div>               
            </div>
            {openModal && <ModalLogout />}
        </header>);
}